import {getAccount} from '~/api/account';
import {cookieItems} from '~/composables/useVzFetch';

const useOrderConfirmPhone = () => {
  const username = useCookie(cookieItems.username)
  const accountPhone = ref('')

  const confirmedCreateUserPhone = computed(() => {
    return (username.value.length > 0 && accountPhone.value.length === 0) || username.value.length === 0
  })

  async function getCheckedAccountPhone() {
    if (!username.value) {
      return false
    }
    if (accountPhone.value) {
      return accountPhone.value
    }

    await getAccountPhone()
    return accountPhone.value || false
  }

  async function getAccountPhone(): Promise<void> {
    accountPhone.value = ''
    const {phone} = await getAccount()
    if (phone) {
      accountPhone.value = phone
    }
  }

  return {
    getCheckedAccountPhone, confirmedCreateUserPhone, accountPhone
  }
}

export default useOrderConfirmPhone